import { fetch } from '@/plugin/axiosNoLogin'
const serverName = '/maintain'

export function getOrderPageList(data) {
  return fetch({
    url: serverName + '/api/maintainOrderList',
    method: 'POST',
    data
  })
}